import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import Modal from 'react-bootstrap/Modal';
import ScheduleBookingDate from './ScheduleBookingDate';
import { closeScheduledBookingModal } from '../../../actions/siteadmin/modalActions';
import messages from '../../../locale/messages';


class ScheduleBookingModal extends Component {

    render() {
        const { scheduleBookingModal, closeScheduledBookingModal, bookingData, isViewPage } = this.props;
        const { initialValues } = this.props;
        return (
            <Modal show={scheduleBookingModal} onHide={closeScheduledBookingModal} dialogClassName='commonModalContainer' >
                <Modal.Header closeButton className='commonModalHeader'>
                    <Modal.Title>
                        <div className="commonModalTitle">
                            {isViewPage ? <FormattedMessage {...messages.editDateTime} /> : <FormattedMessage {...messages.chooseDateTime} />}
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className='commonModalBody'>
                    <ScheduleBookingDate
                        initialValues={initialValues}
                        isViewPage={isViewPage}
                        bookingData={bookingData}
                    />
                </ Modal.Body >
            </Modal>
        )
    }
}

const mapState = (state) => ({
    scheduleBookingModal: state.adminModalStatus.scheduleBookingModal
});

const mapDispatch = {
    change,
    closeScheduledBookingModal
};

export default injectIntl((connect(mapState, mapDispatch)(ScheduleBookingModal)));
